import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskErrorDetailModule } from './task-error-detail/task-error-detail.module';
import { TaskBatchComponent } from './task-batch.component';
import { CoreModule } from '@dm/core';
import { TaskBatchStrService } from './task-batch-str.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        TaskErrorDetailModule,
    ],
    declarations: [TaskBatchComponent],
    exports: [TaskBatchComponent],
    providers: [TaskBatchStrService],
})
export class TaskBatchModule { }
